<div class="container padding-top padding-bottom">
  <md-card *ngIf="locationData; else loading">
    <div class="row">
      <div class="col-md-12">
        <button class="btn btn-primary"
                color="primary"
                (click)="goBack()">Go Back</button>
      </div>
      <div class="col-md-12 text-center">
        <img src="{{clientData?.logoUrl}}"
             class="logo"
             alt="">
        <h1>{{ clientData?.name }}</h1>
        <h3><b>{{ locationData?.name }}</b></h3>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-xs-12 d-flex justify-content-center align-items-center">
        <md-slide-toggle [(ngModel)]="locationData.payForCheckoutCharges"
                         (change)="saveChargeToggle($event)">
          <h4>Actually Charge for Items</h4>
        </md-slide-toggle>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-xs-12 d-flex justify-content-center align-items-center">
        <md-slide-toggle [(ngModel)]="locationData.checkoutChargesExcludeParkingAndOffice"
                         (change)="saveExcludeToggle($event)">
          <h4>Exclude Parking and Office</h4>
        </md-slide-toggle>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-xs-12">
        <h3>Current Checkout Charges (only POS Items for now)</h3>
        <table class="table table-bordered table-striped table-hover">
          <thead>
            <tr>
              <th>Charge ID</th>
              <th>Description</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let c of locationData?.checkoutCharges">
              <td>{{ c.ChargeDescID }}</td>
              <td>{{ c.sChgDesc }}</td>
              <td style="width:1px;white-space:nowrap">
                <button type="button"
                        class="btn btn-danger float-right"
                        color="primary"
                        (click)="removeCharge(c)">Remove</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-xs-12">
        <div *ngIf="!chargesData; else chargesList"
             style="text-align:center">
          <button (click)="loadPosItemData()"
                  class="btn btn-primary"
                  style="font-size:39px"
                  color="primary">Load Inventory Data</button>
        </div>
        <ng-template #chargesList>
          <div>
            <input pInputText
                   (keyup)="filter()"
                   placeholder="search"
                   [(ngModel)]="filterText">
          </div>
          <div class="charges-list">
            <div *ngFor="let c of filteredData"
                 class="charge my-4">
              <div class="charge-add">
                <button type="button"
                        class="btn btn-accent"
                        color="accent"
                        (click)="addCharge(c)">
                  Add
                </button>
              </div>
              <table class="table table-bordered table-striped table-hover">
                <tr>
                  <td>Charge ID</td>
                  <td>{{ c.ChargeDescID }}</td>
                </tr>
                <tr>
                  <td>Description</td>
                  <td>{{ c.sChgDesc }}</td>
                </tr>
                <tr>
                  <td>Price</td>
                  <td>{{ c.dcPrice | currency:'USD':'symbol-narrow':'.2-2' }}</td>
                </tr>
                <tr>
                  <td>Tax 1 Rate</td>
                  <td>{{ c.dcTax1Rate }}</td>
                </tr>
                <tr>
                  <td>Tax 2 Rate</td>
                  <td>{{ c.dcTax2Rate }}</td>
                </tr>
              </table>
            </div>
          </div>
        </ng-template>
      </div>
    </div>

  </md-card>
</div>
<ng-template #loading>
  <div class="spinner">
    <md-spinner color="accent"></md-spinner>
  </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/location-checkout-charges/location-checkout-charges.component.html